import { Typography } from '@mui/material'
import React from 'react'

function Input_Label({ label }) {
    return (
        <Typography sx={{ fontSize: "1.1rem", textAlign: "left" }}>{label}</Typography>
    )
}

export default Input_Label